// src/components/store/sections/blog-posts/BlogV66TicketpressRoyalViolet.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV66TicketpressRoyalViolet(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={66}
      archKey="ticket_press"
      archLabel="Press Pass Stub Cards"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
